module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_laxa-87672e7efff10f157287f8d56a67cbee.png";